
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strains/[strainSlug]",
      function () {
        return require("private-next-pages/strains/[strainSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strains/[strainSlug]"])
      });
    }
  